import { createStore, applyMiddleware, Middleware } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";

import reducers from "store/reducers";

function configureStore() {
  let middleware: Middleware[] = [thunk];

  if (process.env.NODE_ENV === "development") {
    const logger = createLogger({
      level: "info",
      collapsed: true,
    });
    middleware = [...middleware, logger];
  }

  return createStore(
    reducers,
    composeWithDevTools(applyMiddleware(...middleware))
  );
}

export default configureStore;
